import React, { useState, useCallback } from 'react'
import { CreditCard } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'
import SaveBtn from './SaveBtn'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

const BillingSection: React.FC = () => {
  const { currentTheme: t } = useTheme()
  const [notice, setNotice] = useState(false)

  const closeNotice = useCallback(() => setNotice(false), [])

  return (
    <div>
      <div
        className="flex items-center gap-4 p-5 rounded-2xl mb-5"
        style={{ backgroundColor: t.sectionBackground, border: `1px solid ${t.border}` }}
      >
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center shrink-0"
          style={{ background: t.accentGradient, color: '#fff' }}
        >
          <CreditCard size={20} />
        </div>
        <div>
          <p className="text-sm font-semibold" style={{ color: t.text }}>Starter plan</p>
          <p className="text-xs mt-0.5" style={{ color: t.mutedText }}>No payment method on file</p>
        </div>
      </div>

      <SaveBtn label="Manage billing" fullWidth onClick={() => setNotice(true)} />

      <Dialog open={notice} onOpenChange={setNotice}>
        <DialogContent
          className="py-6 px-8 rounded-2xl shadow-xl max-w-sm w-full border-none"
          style={{ background: t.secondary, color: t.text }}
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold text-center" style={{ color: t.text }}>
              Billing isn't available yet
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-center mt-1" style={{ color: t.mutedText }}>
            Contact support if you'd like to upgrade your plan.
          </p>
          <DialogFooter className="flex justify-center mt-6">
            <Button
              variant="secondary"
              onClick={closeNotice}
              className="px-5 py-2 rounded-lg font-medium h-auto text-sm"
              style={{ background: t.hoverBackground, color: t.text, border: `1px solid ${t.border}` }}
            >
              OK
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(BillingSection)
